import { Component, inject, OnInit } from '@angular/core';
import { Url } from '@df/core/service/url';
import { GtmService } from '@df/module-gtm/gtm.service';
import { NgInject } from '@df/ng/ng-inject';
import { ICmsOutletBlockComponent } from '../outlet-block/icms-outlet-block.component';
@Component({
    selector: 'error-404',
    templateUrl: 'error-404.html',
    standalone: true,
    imports: [ICmsOutletBlockComponent]
})
export class Error404Component implements OnInit {
    private gtmService = inject(GtmService);
    private url = inject(Url);
    ngOnInit(): void {
        this.gtmService.sendEventGA4('404_page', { url: this.url.getPath() });
    }
}
